import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import fetchNotifications from "../../actions/notification_list"
import Notification from "./notification"

export class NotificationList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      notifications: []
    }
  }

  componentDidMount() {
    this.props.fetchNotifications()
  }

  render() {
    if (this.props.loading) {
      return (
        <div className="alert alert-success" role="alert">
          <strong>loading...</strong>
        </div>
      )
    } else {
      return (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Notifications Title</th>
              <th>Sent</th>
            </tr>
          </thead>
          <tbody>
            {this.props.notificationList.map((notification, index) => {
              return (
                <Notification
                  key={index}
                  name={notification.headings.en}
                  sentAfter={notification.send_after}
                  id={notification.id}
                  item={index + 1}
                />
              )
            })}
          </tbody>
        </table>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    notificationList: state.notificationList.notifications,
    loading: state.notificationList.loading
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchNotifications: fetchNotifications
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationList)



/** WEBPACK FOOTER **
 ** ./src/components/notifications/list.js
 **/